import React, { useEffect, useState } from 'react';
import { Button, Container, Heading, Textarea, Text } from '@chakra-ui/react';
import axios from 'axios';
import { CONFIG_BASE_URL } from '../../core/constants';

export default function EventManager() {
  // user and sign-out are provided by AdminLayout; no local sign-out button here
  // useAdmin is intentionally not used to avoid duplicate sign-out UI
  const [content, setContent] = useState('');

  useEffect(() => {
    // fetch current events.json directly from repository via GitHub API
    axios
      .get(`${CONFIG_BASE_URL}/events.json`, {
        headers: { Accept: 'application/vnd.github.v3.raw' }
      })
      .then((r) => setContent(JSON.stringify(r.data, null, 2)))
      .catch(() => setContent('[]'));
  }, []);

  // signOut provided by AdminGuard via useAdmin()

  const save = async () => {
    try {
      await axios.post(
        '/api/github/update-config',
        {
          type: 'event',
          content
        },
        { headers: { 'Content-Type': 'application/json' } }
      );
      alert('Saved');
    } catch (e) {
      alert('Save failed: ' + (e.response?.data?.error || e.message));
    }
  };

  // AdminGuard ensures only authenticated users render child routes

  return (
    <Container p={4} maxW="container.lg">
      <Heading mb={4}>Event Manager</Heading>
      <Text mb={2}>Edit events.json (raw)</Text>
      <Textarea
        value={content}
        onChange={(e) => setContent(e.target.value)}
        minH="60vh"
        fontFamily="monospace"
      />
      <Button mt={2} colorScheme="blue" onClick={save}>
        Save to GitHub
      </Button>
    </Container>
  );
}
